import manageGroup from './manageGroup';

const groupSettings = () => {
	manageGroup();
};

export default groupSettings;
